import generateDirective from '../generator';
import ContractStageController from './controller';

generateDirective('Contract', '/customer_application_renderer/stages/contract/form.html', ContractStageController);
